// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".portlet-container {\n  margin: 20px;\n  margin-top: 40px;\n}\n.portlet-container span {\n  font-size: 14px;\n  color: #7f7f7f;\n}\n\n.portlet-title {\n  padding: 0;\n  min-height: 35px;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 10px;\n}\n\n.caption {\n  display: inline-block;\n  font-size: 18px;\n  line-height: 18px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
